import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Maestro_AliadosPorcentajeBeneficiarios } from '../models/generic/Maestro_AliadosPorcentajeBeneficiarios';

@Injectable({
  providedIn: 'root'
})
export class Maestros_AliadosPorcentajesBeneficiariosService {
  
  ListaAliadosCanales: Maestro_AliadosPorcentajeBeneficiarios[] = [];
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  Consultar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_ALIADOSPORCENTAJEBENEFICIARIOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
